import { SAVEINVOICESETTING_SUCCESS, SAVEINVOICESETTING_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const saveInvoiceSettingReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVEINVOICESETTING_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case SAVEINVOICESETTING_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default saveInvoiceSettingReducer;
